import { apiPostAsUser } from './api_v2';

export const recordChannelView = (channelId) => {
  void apiPostAsUser(`/channels/${channelId}/last_viewed`, {}, { keepalive: true }).catch(() => {});
};
